// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"B6-z"};